export default "__VITE_ASSET__CAGwKu1F__"